import store from "@/store";
import Vue from "vue";
import axios from "axios";
import localApi from "@/util/localApi.js";

const DOMAIN = Vue.prototype.$domain();

const GEN_ENVRELEASE = "https://gen.envrelease.com";
let API = "";

if (localApi()) {
  API = localApi();
} else if (DOMAIN === "sys") {
  API = "https://apidev.sga.bet";
} else if (DOMAIN === "homolog") {
  API = "https://apiv2dev.sga.bet";
} else {
  API = "https://v2.envrelease.com";
}

const casino = {
  async getActiveSlotGames() {
    const endpoint = API + "/casino/games/listByOperator";

    const body = Vue.prototype.$formdata({
      domain: DOMAIN,
    });

    const headers = {
      "Content-Type": "multipart/form-data",
      "x-api-key": "02ff96c8f50ce6a488812146d448a04b2e2358dd45d0dbb59824",
    };

    const games = await axios({
      method: "post",
      url: endpoint,
      data: body,
      headers,
    });

    return games.data.dados.map((game) => ({ ...game, imageLoaded: false }));
  },

  async startGame(gameId) {
    let endpoint = GEN_ENVRELEASE + "/player/games/generateURL";

    if (DOMAIN === "sys" || localApi()) {
      endpoint = API + "/casino/games/generateURL";
    }

    const body = Vue.prototype.$formdata({
      currency: "BRL",
      country: "BRA",
      language: store.state.language,
      symbol: gameId,
      token: store.state.logged.token,
      url: store.state.operators.url,
    });

    const headers = {
      "Content-Type": "multipart/form-data",
      "Application-Authorization": store.state.logged.token,
      "x-api-key": "02ff96c8f50ce6a488812146d448a04b2e2358dd45d0dbb59824",
    };

    const response = await axios({
      method: "post",
      url: endpoint,
      data: body,
      headers,
    });

    return response.data.dados;
  },

  async fetchDgaId() {
    const cachedDgaId = JSON.parse(sessionStorage.getItem("dgaId"));

    if (cachedDgaId) {
      return cachedDgaId;
    }

    let endpoint = GEN_ENVRELEASE + "/player/games/getDgaId";

    if (DOMAIN === "sys" || localApi()) {
      endpoint = API + "/player/games/generateURL";
    }

    const headers = {
      "Content-Type": "multipart/form-data",
      "Application-Authorization": store.state.logged.token,
      "x-api-key": "02ff96c8f50ce6a488812146d448a04b2e2358dd45d0dbb59824",
    };

    const body = Vue.prototype.$formdata({ domain: DOMAIN });

    const response = await axios({
      method: "post",
      url: endpoint,
      data: body,
      headers,
    });

    sessionStorage.setItem("dgaId", JSON.stringify(response.data.dados));
    return response.data.dados;
  },
};

export default casino;
